import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import PageHeader from 'components/common/PageHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MainContentHeader = ({ form }) => {
  if (form && form.headerTitle) {
    return (
      <PageHeader
        col={{ lg: 12 }}
        title={form.headerTitle}
        description={form.headerDescription}
        className="mb-3"
      >
        {form.headerButtonTitle && form.headerButtonUrl && (
          <Button
            href={form.headerButtonUrl}
            target={form.headerButtonTarget}
            variant="link"
            size="sm"
            className="ps-0"
          >
            {form.headerButtonTitle}
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs--2" />
          </Button>
        )}
      </PageHeader>
    );
  } else {
    return null;
  }
};

MainContentHeader.propTypes = {
  form: PropTypes.object
};

export default MainContentHeader;
